(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:usuarisHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris')
    .value('permisosUsuarisHeaderSubmenuLinksValue',  {
      'name'     : 'usuaris.main',
      'addPermit'    : 'AFEGIRUSUARI',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'usuaris.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'LOGIN',
            'stateOptions' : {'reload': 'usuaris.main.submain'}
          }
      }
    });
}());
